'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkStatusPermission;

var _userStatus = require('../constants/userStatus');

var _userStatus2 = _interopRequireDefault(_userStatus);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var statuses = Object.keys(_userStatus2.default);
/* Example of usage
===================
  If you need render smth from "USER_DATA_FILLED" status and higher;
  checkStatusPermission("NAME_OF_CURRENT_STATUS", "USER_DATA_FILLED") ? renderSmth() : renderSmth2();
  It's equal to -
  !"NA" && !"APPLIED" && !"REGISTERED" && !"INVITED" && !"CONFIRMED"
*/

function checkStatusPermission(currentStatus, necessaryForPassage) {
  var currentIndex = statuses.indexOf(currentStatus);
  var necessaryIndex = statuses.indexOf(necessaryForPassage);
  return currentIndex >= necessaryIndex;
}